// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"38b3342b0218fd23","5763":"b52de39b83559913","6893":"80d543f4ba1bccef","6974":"038c0c8eb7c62993","7222":"85cf415b4d5c271d","7937":"700dfdd72147a648"}[chunkId] + ".js";
};